
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/modal";
import { useState } from "react";

export const CreateQuoteModal = ({ isOpen, onClose, onSend }: { isOpen: boolean; onClose: () => void; onSend: () => Promise<void>; }) => {
  const [loading, setLoading] = useState(false);
  const handleSend = async () => {
    setLoading(true);
    await onSend();
    setLoading(false);
    onClose();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Submit quote request"
      size="sm"
      showHeader={true}
      footer={
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose} disabled={loading}>Close</Button>
          <Button onClick={handleSend} disabled={loading} className="bg-black text-white hover:bg-gray-800">
            {loading ? "Sending..." : "Submit request"}
          </Button>
        </div>
      }
    >
      <div className="p-4 my-4 text-sm text-gray-700">
        The request will be sent to a Place2Be admin who must approve it before it is sent to the client.
      </div>
    </Modal>
  );
};